<template>
  <div class="header-wrapper row m-0">
    <Logo />
    <div class="left-header col-xxl-5 col-xl-6 col-lg-5 col-md-4 col-sm-3 p-0">
      <h3><b>Welcome, {{ username }} </b></h3>
    </div>
    <div class="nav-right col-xxl-7 col-xl-6 col-md-7 col-8 pull-right right-header p-0 ms-auto">
      <ul class="nav-menus">
        <li>
          <router-link to="/">
            <button class="btn btn-block">View Site</button>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { getRequest } from "@/services/RequestService";
import Logo from './logo.vue';

export default {
  components: {
    Logo,
  },
  data() {
    return {
      username: '',
    };
  },

  methods: {
    async loadUser() {
      const authToken = localStorage.getItem("token");
      const user_details = JSON.parse(localStorage.getItem("user_details"));

      if (!authToken || !user_details) {
        throw new Error("Authentication information is missing.");
      }

      const user_id = user_details.id;

      const response = await getRequest(`/users/${user_id}/view`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (response.data.success === false) {
        throw new Error("Error encountered. Please try again.")
      }

      this.username = response.data.data.username;
    }
  },

  async mounted() {
    this.loadUser();
  },
};
</script>

<style scoped>
.nav-menus button {
  border: 1px black solid;
  width: 7rem;
}
</style>
